import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/layouts/blank.vue")),
  "components-default-layout-with-vertical-nav": defineAsyncComponent(() => import("/app/layouts/components/DefaultLayoutWithVerticalNav.vue")),
  "components-footer": defineAsyncComponent(() => import("/app/layouts/components/Footer.vue")),
  "components-nav-items": defineAsyncComponent(() => import("/app/layouts/components/NavItems.vue")),
  "components-navbar-theme-switcher": defineAsyncComponent(() => import("/app/layouts/components/NavbarThemeSwitcher.vue")),
  "components-user-profile": defineAsyncComponent(() => import("/app/layouts/components/UserProfile.vue")),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue"))
}